<style scoped>
.txt-sert-reg h2{
    color: #E38D5F;
    font-weight: bold;
}
.txt-sert-rpl h2{
    color: #1875F0;
    font-weight: bold;
}
.txt-pelatihan h2{
    color: #A72F6B;
    font-weight: bold;
}
.txt-keanggotaan h2{
    color: #2F4EA7;
    font-weight: bold;
}
</style>
<template>
    <CRow>
        <div class="col-xl-3 col-sm-12 col-lg-6 col-md-6 d-flex">
            <div class="card border-0 rounded flex-fill">
                <div class="card-body d-flex align-items-center justify-content-between">
                    <div>
                        <h6 class="font-weight-bold">Sertifikasi Reguler</h6>
                        <p class="mb-0 text-muted">Total Peserta</p>
                        <small class="font-weight-medium text-muted">Periode: {{ dataDashboard.sertifikasi.periode }}</small>
                    </div>
                    <div class="txt-sert-reg mt-4">
                        <h2>{{ dataDashboard.sertifikasi.jumlahPeserta }}</h2>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl-3 col-sm-12 col-lg-6 col-md-6 d-flex">
            <div class="card border-0 rounded flex-fill">
                <div class="card-body d-flex align-items-center justify-content-between">
                    <div>
                        <h6 class="font-weight-bold">Sertifikasi RPL</h6>
                        <p class="mb-0 text-muted">Total Peserta</p>
                        <small class="font-weight-medium text-muted">Periode: {{ dataDashboard.rpl.periode }}</small>
                    </div>
                    <div class="txt-sert-rpl mt-4">
                        <h2>{{ dataDashboard.rpl.jumlahPeserta }}</h2>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl-3 col-sm-12 col-lg-6 col-md-6 d-flex">
            <div class="card border-0 rounded flex-fill">
                <div class="card-body d-flex align-items-center justify-content-between">
                    <div>                        
                        <h6 class="font-weight-bold">Pelatihan</h6>
                        <p class="mb-0 text-muted">Total Peserta</p>
                        <small class="font-weight-medium text-muted">Tahun : {{ tahun }}</small>
                    </div>
                    <div class="txt-pelatihan mt-4">
                        <h2>{{ dataDashboard.pelatihan.jumlahDataPeserta }}</h2>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl-3 col-sm-12 col-lg-6 col-md-6 d-flex">
            <div class="card border-0 rounded flex-fill">
                <div class="card-body d-flex align-items-center justify-content-between">
                    <div>
                        <h6 class="font-weight-bold">Keanggotaan</h6>
                        <p class="mb-0 text-muted">Total Anggota</p>
                        <small class="font-weight-medium text-muted">Tahun: {{ tahun }}</small>
                    </div>
                    <div class="txt-keanggotaan mt-4">
                        <h2>{{ dataDashboard.keanggotaan.jumlahAnggota }}</h2>
                    </div>
                </div>
            </div>
        </div>
    </CRow>
</template>
<script>

export default {
  data() {
    return {
        tahun : ''
    };
  },
  props : [
    'dataDashboard'
  ],
  mounted() {
    this.tahun = new Date().getFullYear();
    this.getData();
  },

  methods: {
    getData() {
     
    },
  },
};
</script>